<template>
    <select-box-component v-model="selectedGender"
                          :options="genders"
                          name="Genders"
                          :title="translate.user_features.gender"
                          :description="translate.home.selectPreferredGender"
                          :triggerClass="['btn btn-with-gallery-filter', {'btn-with-gallery-filter--active': hasGenderFilter}]"
                          optionClass="small"
                          @change="onGenderChange">
        <template #trigger>
            {{translate.user_features.gender}}
        </template>
    </select-box-component>
</template>

<script>
import SelectBoxComponent from "@/components/partials/SelectBoxComponent.vue";
import IconComponent from "@/components/global/IconComponent.vue";

const data = () => {
    return {
        selectedGender: 'Weiblich',
        isExplicitlySet: false,
    }
}

function mounted() {
    this.setGenderFromValue(this.features.gender);
}

function setGenderFromValue(gender) {
    // Default to 'Weiblich' if gender is undefined, otherwise use the actual value (including null for "All")
    if (gender !== undefined) {
        this.selectedGender = gender;
        this.isExplicitlySet = true;
    } else {
        this.selectedGender = 'Weiblich';
        this.isExplicitlySet = false;
    }
}

function onGenderChange() {
    this.isExplicitlySet = true;
    this.$emit('gender-changed', this.selectedGender);
}

function hasGenderFilter() {
    return this.isExplicitlySet;
}

export default {
    components: {IconComponent, SelectBoxComponent},
    data,
    mounted,
    computed: {
        ...mapState(['translate', 'features']),
        hasGenderFilter,
        genders() {
            return [
                {value: 'Weiblich', label: this.translate.user_features.genders.female},
                {value: 'Transsexuell', label: this.translate.user_features.genders.transsexual},
                {value: 'Männlich', label: this.translate.user_features.genders.male},
                {value: null, label: this.translate.home.all},
            ]
        },
    },
    methods: {
        onGenderChange,
        setGenderFromValue,
    },
    watch: {
        'features.gender': {
            handler(newVal) {
                this.setGenderFromValue(newVal);
            },
            immediate: true,
        }
    }
}
</script>
